import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BrowserService } from '../../services/browser.service';
import { WindowRef } from '../../services/windowRef';

@Component({
  selector: '[data-component="tooltip"]',
  templateUrl: './tooltip.component.html',
})
export class TooltipComponent implements OnInit, OnDestroy {
  @ViewChild('tooltip', { static: true }) tooltipElement: ElementRef;
  @Input() formInputName: string;
  @Input() text: string;
  @Input() label: string;
  @Input() helpIcon: boolean = false;
  @Output() onClick: EventEmitter<any> = new EventEmitter();

  public visible: boolean = false;
  public positionX: string = 'center';
  public positionY: string = 'top';

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    public browserService: BrowserService,
    private windowRef: WindowRef
  ) {}

  ngOnInit() {
    this.subscribeResizeCount();
    setTimeout(() => this.setPosition());
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public getARIALabelText(): string {
    const text = 'Tooltip: ' + this.text;
    return this.formInputName ? `${this.formInputName} ${text}` : text;
  }

  public click(e: any): void {
    e.preventDefault();
    this.onClick.emit();

    if (this.browserService.isIOS()) {
      this.tooltipElement.nativeElement.focus();
    }
  }

  public show(): void {
    this.visible = true;
  }

  public hide(): void {
    this.visible = false;
  }

  private subscribeResizeCount(): void {
    this.browserService.resizeCount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((viewport) => {
        this.setPosition();
      });
  }

  private setPosition(): void {
    const windowWidth = this.windowRef.windowWidth();
    if (windowWidth == 0) {
      this.positionX = 'center';
      return;
    }

    const left = this.tooltipElement.nativeElement.getBoundingClientRect().left;
    if (left > 0 && left < 90) {
      this.positionX = left < 40 ? 'right' : 'half-right';
      return;
    }

    if (left + 130 > windowWidth) {
      this.positionX = left + 80 > windowWidth ? 'left' : 'half-left';
      return;
    }

    this.positionX = 'center';
  }
}
